import React, { useCallback, useMemo, useState } from 'react'

import MultiSelectChips from 'material/MultiSelectChips'
import Select from 'material/Select'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getSegmentValue } from 'components/SegmentSelector/segment-service'
import { isInUnitedStates, selectState } from 'store/college'

import { withContext } from '../Context'
import { ALL_STATES, INDIVIDUAL_TYPE, OPTIONS, getAppropriateOptionType, getOptions } from './state-service'

export const SegmentName = 'USAState'

export const StateSelector = ({ criteria, segment, collegeState, onChange, isInUnitedStates }) => {
  const currentValue = getSegmentValue(segment, criteria, SegmentName)
  const initialType = useMemo(() => getAppropriateOptionType(currentValue, collegeState), [currentValue, collegeState])
  const [type, setType] = useState(initialType)
  const change = useCallback((value) => onChange(criteria, SegmentName, value), [criteria, onChange])

  const setSelectionType = (type) => {
    change(OPTIONS[type].getDefaultValue(collegeState))
    setType(type)
  }
  const typeOptions = getOptions(isInUnitedStates)

  return (
    <>
      <div>
        <Select
          id="segmentation-state-type-selector"
          label="Student High School State"
          value={type}
          options={typeOptions}
          onChange={setSelectionType}
        />
      </div>
      <div>
        {type === INDIVIDUAL_TYPE && (
          <MultiSelectChips
            value={currentValue}
            id="segmentation-state-multi-selector"
            label="Selected States"
            options={ALL_STATES}
            onChange={change}
          />
        )}
      </div>
    </>
  )
}

StateSelector.propTypes = {
  criteria: PropTypes.string.isRequired,
  segment: PropTypes.object,
  isInUnitedStates: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  collegeState: PropTypes.string.isRequired,
}

StateSelector.defaultProps = {
  criteria: 'Must',
  isInUnitedStates: false,
}

export const ConnectedStateSelector = connect((store) => ({
  collegeState: selectState(store),
  isInUnitedStates: isInUnitedStates(store),
}))(StateSelector)

export default withContext(ConnectedStateSelector)
